<template>
  <v-container fluid pa-0>
    <!-- Individual Position -->
    <helpers-section-sub-header>Share this trading model:</helpers-section-sub-header>
    <p>
      If you have your <a to="/user">"Social Visibility"</a> turned on then you can share this
      trading model with the WhaleWisdom community or just a few cohorts. Shared trading models will
      be made available at the new
      <a href="/whale_watching">WhaleWisdom Community Portal</a>
    </p>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="current_trading_model.social_visibility_id"
          :items="social_visibility_types"
          label="Who can view this trading model?"
          item-value="id"
          item-title="description"
          style="max-width: 350px"
        />
      </v-col>
      <v-col v-show="current_trading_model.social_visibility_id == 3" cols="12">
        <v-row>
          <v-col cols="12">
            <h3>Users that can see this trading model</h3>
            <v-chip
              v-for="user in current_trading_model.users_shared_with"
              :key="user.id"
              small
              close
              class="ma-1"
              color="primary text-white"
              label
              @update:active="removeUserById(user.id)"
            >
              <v-avatar v-if="user.avatar">
                <img :src="user.avatar" />
              </v-avatar>
              {{ user.name }}
            </v-chip>
          </v-col>
          <h4 v-if="current_trading_model.users_shared_with.length == 0">No users added yet.</h4>
          <v-col cols="12">
            <v-row density="compact">
              <v-col cols="auto">
                <v-text-field
                  v-model="search"
                  density="compact"
                  style="max-width: 400px"
                  label="Lookup User"
                  hide-details
                  variant="outlined"
                />
              </v-col>
              <v-col cols="auto">
                <v-btn @click="addUser()"> Add user </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <div />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="current_trading_model.body"
          variant="outlined"
          name="input-7-4"
          label="Optional description of this trading model"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import { mapFields } from '@/store/helpers'
import api from '@/store/api'
import axios from 'axios'
export default {
  data: () => ({
    friends: [],
    loading: false,
    count: 0,
    search: null,
    saving: false,
    nonce: 1,
    activator: null,
    attach: null,
    social_visibility_types: [
      { id: 0, description: 'No sharing' },
      { id: 1, description: 'Visible to everyone' },
      { id: 3, description: 'Only specific users added here can see' }
    ]
  }),
  computed: {
    ...mapFields({
      criteria: 'app.whaleTraderCriteria',
      current_trading_model: 'app.current_trading_model'
    })
  },
  watch: {},
  methods: {
    addUser() {
      var that = this
      axios
        .get('/social/relationships/find_user?name=' + this.search, {})
        .then(function (response) {
          console.log(response)
          if (response.data && response.data.id > 0) {
            that.current_trading_model.users_shared_with.push(response.data)
            that.search = ''
            that.saving = true
            that.results = null
            api
              .post('save_trading_model', that.current_trading_model)
              .then(response => {
                //  useUserStore().loadTradingModels()
              })
              .catch(error => {
                useAppStore().showNotification({
                  type: 'error',
                  text: (error.response && error.response.data) || error.message
                })
              })
              .then(() => (that.saving = false))
          } else {
            useAppStore().showNotification({
              type: 'error',
              text: 'User not found'
            })
          }
        })
        .catch(function (error) {
          console.log(error)
          useAppStore().showNotification({
            type: 'error',
            text: (error.response && error.response.data) || error.message
          })
        })
        .then(function () {})
    },
    removeUserById(id) {
      const index = this.current_trading_model.users_shared_with.findIndex(filer => filer.id === id)
      this.current_trading_model.users_shared_with.splice(index, 1)
    }
  }
}
</script>
